import { render, staticRenderFns } from "./BrazilVBtn.vue?vue&type=template&id=0f0a5ab9&scoped=true&"
import script from "./BrazilVBtn.vue?vue&type=script&lang=js&"
export * from "./BrazilVBtn.vue?vue&type=script&lang=js&"
import style0 from "./BrazilVBtn.vue?vue&type=style&index=0&id=0f0a5ab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a5ab9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
